import { render, staticRenderFns } from "./boughtDetail.vue?vue&type=template&id=e4e50418&scoped=true"
import script from "./boughtDetail.vue?vue&type=script&lang=js"
export * from "./boughtDetail.vue?vue&type=script&lang=js"
import style0 from "./boughtDetail.vue?vue&type=style&index=0&id=e4e50418&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e50418",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4e50418')) {
      api.createRecord('e4e50418', component.options)
    } else {
      api.reload('e4e50418', component.options)
    }
    module.hot.accept("./boughtDetail.vue?vue&type=template&id=e4e50418&scoped=true", function () {
      api.rerender('e4e50418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cooperationMall/newCooperationMall/detail/boughtDetail.vue"
export default component.exports